
import { Button } from "@/components/ui/button";
import { SaveIcon, Loader2 } from "lucide-react";
import { useParams } from "react-router-dom";
import { useTranslations } from "@/hooks/useTranslations";

interface StudentFormHeaderProps {
  isSubmitting: boolean;
  onSubmit: () => void;
  isEditing: boolean;
}

export const StudentFormHeader = ({ isSubmitting, onSubmit, isEditing }: StudentFormHeaderProps) => {
  const { t } = useTranslations("students");
  
  // Este componente não tem mais o botão de salvar,
  // pois foi movido para as páginas NewStudent e EditStudent
  
  return null;
};
